<template>
  <div>
    <DeleteModal
      modalId="modal-clinic-attachment-delete"
      @deleteToggle="deleteItem"
    />

    <b-row>
      <b-col cols="12" sm="12">
        <b-card :title="$t('common.attachments')">
          <b-row>
            <b-col
              class="p-1 m-1 d-flex flex-column align-items-center"
              v-for="(file, index) in data"
              :key="index"
            >
              <div class="d-flex align-self-end justify-content-end mb-1">
                <b-button
                  pill
                  variant="outline-danger"
                  size="sm"
                  @click="deleteModel(file)"
                  >{{ $t("common.delete") }}</b-button
                >
              </div>

              <div class="" @click="openFileInNewTab(file.attachment)">
                <b-img
                  :src="file.attachment_url"
                  style="
                    width: 150px;
                    height: 150px;
                    object-fit: cover;
                    cursor: pointer;
                  "
                ></b-img>
              </div>
            </b-col>
          </b-row>
          <DropFile
            :getAttachments="getAttachments"
            :attachableType="attachableType"
            :attachableId="attachableId"
            :type="type"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormInput,
  BImg,
} from "bootstrap-vue";

const DropFile = () => import("@/components/common/DropFile.vue");
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormGroup,
    BCard,
    BCardText,
    BButton,
    BImg,
    DropFile,
    DeleteModal,
  },
  data() {
    return {
      data: [],
    };
  },
  props: ["attachableId", "attachableType", "type"],
  mounted() {
    this.getAttachments();
  },

  methods: {
    openFileInNewTab(filePath) {
      window.open(filePath, "_blank");
    },
    async getAttachments() {
      this.loading = true;

      let url = `/attachment?filter[attachable_type]=${this.attachableType}&take=20&filter[attachable_id]=${this.attachableId}`;

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
      this.EditForm.attachment = "";
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-clinic-attachment-delete");
    },
    deleteItem() {
      const deleteURL =
        this.type === "CLINIC"
          ? `/clinic-attachment/${this.deleteForm.id}`
          : `/attachment/${this.deleteForm.id}`;
      this.$store
        .dispatch("delete", deleteURL)
        .then((response) => {
          this.getAttachments();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
